export default "__VITE_ASSET__6b99fc0b__"